import React, { useState, useEffect } from "react";
import styles from "./QuizStream.module.css";
import QuizModal from "../QuizModal/QuizModal";
import { useSelector } from "react-redux";

const QuizStream = ({ quizId, onSubmissionSuccess }) => {
  const quizStreamData =
    useSelector((state) => state?.courses?.quizStreamData) ?? [];
  const quizSubmissionData =
    useSelector((state) => state?.quiz?.quizSubmission);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentGrade, setCurrentGrade] = useState(null);
  const [submissionResponse, setSubmissionResponse] = useState(null);

  // find quiz by id instead of always index 0
  const currentQuizStreamData =
    quizStreamData.find((q) => q.quiz?.id === quizId)?.quiz ?? {};

  // Update grade when submission data changes
  useEffect(() => {
    if (submissionResponse && submissionResponse.marks !== undefined) {
      setCurrentGrade(submissionResponse.marks);
    } else if (quizSubmissionData && quizSubmissionData.marks !== undefined) {
      setCurrentGrade(quizSubmissionData.marks);
    } else if (currentQuizStreamData?.user_submission?.marks !== undefined) {
      setCurrentGrade(currentQuizStreamData.user_submission.marks);
    }
  }, [quizSubmissionData, currentQuizStreamData, submissionResponse]);

  const handleStartQuiz = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmissionSuccess = (response) => {
    console.log('Submission successful:', response);
    
    // Extract the submission data from the response
    // Response structure: response.payload.data.update_quiz_submission
    const submissionData = response?.payload?.data?.update_quiz_submission || 
                          response?.data?.update_quiz_submission || 
                          response;
    
    if (submissionData) {
      setSubmissionResponse(submissionData);
      setCurrentGrade(submissionData.marks);
      // Forward the submission response to parent (if provided)
      if (onSubmissionSuccess) {
        try {
          onSubmissionSuccess(response);
        } catch (e) {
          console.warn('Parent onSubmissionSuccess threw', e);
        }
      }
    }
  };

  // Function to display grade with proper formatting
  const displayGrade = () => {
    if (currentGrade !== null && currentGrade !== undefined) {
      return currentGrade;
    }
    return currentQuizStreamData?.user_submission?.marks || '-';
  };

  // Function to check if quiz is submitted
  const isQuizSubmitted = () => {
    return submissionResponse?.is_submitted || 
           currentQuizStreamData?.user_submission?.is_submitted || 
           false;
  };

  return (
    <div className={styles.quizPage}>
      <h1 className={styles.title}>
        {currentQuizStreamData?.title || 'Quiz Title'}<span>*</span>
      </h1>
      <p className={styles.subtitle}>Quiz: {currentQuizStreamData?.template?.ques_count || 0} Question(s)</p>

      <div className={styles.instructions}>
        <h3>Instructions</h3>
        <p>{currentQuizStreamData?.details || 'Instructions'}</p>
      </div>

      <div className={styles.footer}>
        <div>
          <strong>Max. Marks:</strong> {currentQuizStreamData?.max_marks || 0}
        </div>
        <div>
          <strong>Your Grade:</strong> {displayGrade()}
        </div>
        {isQuizSubmitted() && (
          <div>
            <strong>Status:</strong> <span style={{color: 'green'}}>Submitted</span>
          </div>
        )}
      </div>

      <button 
        className={styles.startButton} 
        onClick={handleStartQuiz}
        disabled={isQuizSubmitted()}
      >
        {isQuizSubmitted() ? 'QUIZ COMPLETED' : 'START QUIZ'}
      </button>

      {isModalOpen && (
        <QuizModal 
          onClose={handleCloseModal} 
          quizData={currentQuizStreamData}
          onSubmissionSuccess={handleSubmissionSuccess}
        />
      )}
    </div>
  );
};

export default QuizStream;